import promise from "redux-promise-middleware";

import { logger } from './logger';

export default [
  promise(),
  logger
];


// WEBPACK FOOTER //
// ./src/store/middleware/index.js